<template>
  <user-form
    :title="$t('label.editUser')"
    :validations="validations"
    @submit="onSubmit"
  />
</template>

<script>
import UserForm from './Form'

export default {
  name: 'Edit',
  metaInfo () {
    return {
      title: this.$t('label.editUser'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  components: {
    UserForm
  },
  data () {
    return {
      validations: {}
    }
  },
  methods: {
    onSubmit (user) {
      this.validations = {}
      const permissions = user.permissions.map(permission => ({
        id: permission.id,
        name: permission.name
      }))
      this.$axios.post(process.env.VUE_APP_API + '/api/v1/user/update', {
        ...{ ...user, permissions: permissions }
      }).then(() => {
        this.$toastr(
          'success',
          this.$t('string.theRequestHaveBeenProcessed'),
          this.$t('string.success')
        )
        this.$router.push({
          name: 'list-user'
        })
      }).catch((error) => {
        if (error.response.status === 422) {
          this.validations = error.response.data.errors
        }
        this.onResponseError(error)
      })
    }
  }
}
</script>

<style scoped>

</style>
